import { StyledSvg } from "baseui/icon";
import React from "react";

export const CustomerWishlistTemplateIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.332031" width="20" height="20" rx="4" fill="#F8FFF0" />
    <path d="M8.5 5.5H16.1667" stroke="#558B2E" strokeMiterlimit="10" strokeLinecap="round" />
    <path
      d="M5.5 15.5C6.05228 15.5 6.5 15.0523 6.5 14.5C6.5 13.9477 6.05228 13.5 5.5 13.5C4.94772 13.5 4.5 13.9477 4.5 14.5C4.5 15.0523 4.94772 15.5 5.5 15.5Z"
      fill="#558B2E"
    />
    <path
      d="M5.5 11C6.05228 11 6.5 10.5523 6.5 10C6.5 9.44772 6.05228 9 5.5 9C4.94772 9 4.5 9.44772 4.5 10C4.5 10.5523 4.94772 11 5.5 11Z"
      fill="#558B2E"
    />
    <path
      d="M5.5 6.5C6.05228 6.5 6.5 6.05228 6.5 5.5C6.5 4.94772 6.05228 4.5 5.5 4.5C4.94772 4.5 4.5 4.94772 4.5 5.5C4.5 6.05228 4.94772 6.5 5.5 6.5Z"
      fill="#558B2E"
    />
    <path
      d="M8.5 10.5H11.0487C11.5453 10.037 12.149 9.68967 12.821 9.5H8.5C8.22367 9.5 8 9.72367 8 10C8 10.2763 8.22367 10.5 8.5 10.5Z"
      fill="#558B2E"
    />
    <path
      d="M9.68367 14H8.5C8.22367 14 8 14.224 8 14.5C8 14.776 8.22367 15 8.5 15H9.878C9.77467 14.6813 9.71 14.3463 9.68367 14Z"
      fill="#558B2E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.332 13.6667C10.332 11.6417 11.9737 10 13.9987 10C16.0237 10 17.6654 11.6417 17.6654 13.6667C17.6654 15.6917 16.0237 17.3333 13.9987 17.3333C11.9737 17.3333 10.332 15.6917 10.332 13.6667ZM12.4381 15.8333L13.9988 15.019L15.5595 15.8333L15.2881 14.069L16.5095 12.8476L14.7453 12.5762L13.9988 11.0833L13.2524 12.5762L11.4881 12.8476L12.7095 14.069L12.4381 15.8333Z"
      fill="#558B2E"
    />
  </StyledSvg>
);
